import { Tooltip } from 'devextreme-react';
import { CommonSeriesSettings, Chart, SeriesTemplate, ValueAxis, ArgumentAxis, Label, Series, Legend, AxisTitle, AxisLabel, Crosshair, Title, Point, Grid, Export, CommonAxisSettings, ConstantLine, Format, ArgumentFormat } from 'devextreme-react/chart';
import React, { Component } from 'react';
import { apiGetP } from '../../GanjiTools';
import Spinner from '../utils/Spinner';


class XYPlot extends Component {
    state = {
        error: 'Not loaded yet.',
        data: [],
        atDate: this.props.atDate ?? new Date(),
        loading: true,
    }

    loadData = (assetId, recoms) => {
        if (!(assetId > 0)) {
            this.setState({ error: 'Invalid asset id: ' + assetId });
            return;
        }
        this.setState({ loading: true }, () => {
            apiGetP(`/api/rbi/calcRiskCurve?assetId=${assetId}&inspJsn=${JSON.stringify(recoms ?? [])}`)
                .catch(err => this.setState({ error: err?.toString() ?? 'load error' }))
                .then(res => {
                    res ??= { error: 'No response.' };
                    if (res.error?.length > 0)
                        this.setState({ error: res.error, loading: false });
                    else
                        this.setState({ ...res, loading: false, riskVsDate: res.data?.map(a => ({ dt: a.dt, risk: a.pof * res.cof_f })), error: '' });
                })
        });
    }

    componentDidMount() {
        let recoms = (this.props.recoms ?? []).map(x => ({
            ymd: x.date?.split('T')[0]?.replaceAll('-', '/') ?? '',
            na: x.na ?? 0,
            nb: x.nb ?? 0,
            nc: x.nc ?? 0,
            nd: x.nd ?? 0,
            ne: x.ne ?? 0
        }));

        this.loadData(this.props.assetId, recoms);
    }

    render() {
        return (this.state.loading ? <Spinner /> : this.state.error?.length > 0 ? <p style={{ padding: '3rem' }}>{this.state.error}</p> :
            <div style={{ margin: '1rem', minWidth: 'calc(90% - 300px)', backgroundColor: 'white', borderRadius: '10px' }}>
                <Chart id='pxy' dataSource={this.state.data} width='inherit' //height='320px'
                    resolveLabelOverlapping='hide'
                >
                    <CommonAxisSettings grid={{ visible: true, color: 'gray', opacity: '15%' }} />

                    {/* <Title text='AA' /> */}

                    {(this.props.curve ?? 'risk_f') === 'risk_f' &&
                        <Series type='spline' valueField='risk_f' axis='risk' argumentField='dt' point={{ visible: false }}
                        />
                    }
                    {(this.props.curve ?? 'risk_f') === 'risk_f' &&
                        <ValueAxis title='Financial Risk' type={this.props.logScale ? 'logarithmic' : 'continuous'}
                            name='risk' position='left' endOnTick
                        >
                            <ConstantLine value={this.state.riskTargetF} dashStyle='dash' color='red' label={{ text: 'Target Risk' }} />
                        </ValueAxis>
                    }
                    {this.props.curve === 'risk_a' &&
                        <Series type='spline' valueField='risk_a' axis='risk' argumentField='dt' point={{ visible: false }}
                        />
                    }
                    {this.props.curve === 'risk_a' &&
                        <ValueAxis title='Area Risk' type={this.props.logScale ? 'logarithmic' : 'continuous'}
                            name='risk' position='left' endOnTick
                        >
                            <ConstantLine value={this.state.riskTargetA} dashStyle='dash' color='red' label={{ text: 'Target Risk' }} />
                        </ValueAxis>
                    }
                    {this.props.curve === 'df_total' &&
                        <Series type='spline' valueField='df_total' axis='risk' argumentField='dt' point={{ visible: false }}
                        />
                    }
                    {this.props.curve === 'df_total' &&
                        <ValueAxis title='Total Damage Factors' type={this.props.logScale ? 'logarithmic' : 'continuous'}
                            name='risk' position='left' endOnTick grid={false}
                        >
                            <ConstantLine value={1} dashStyle='solid' width='3px' color='green' label={{ text: '' }} />
                            <ConstantLine value={10} dashStyle='solid' width='3px' color='yellow' label={{ text: '' }} />
                            <ConstantLine value={100} dashStyle='solid' width='3px' color='orange' label={{ text: '' }} />
                            <ConstantLine value={1000} dashStyle='solid' width='3px' color='red' label={{ text: '' }} />
                            <ConstantLine value={this.state.riskTargetDfTotal} dashStyle='dash' color='black' label={{ text: 'Target DF' }} />
                        </ValueAxis>
                    }
                    {this.props.curve === 'pof' &&
                        <Series type='spline' valueField='pof' axis='risk' argumentField='dt' point={{ visible: false }}
                        />
                    }
                    {this.props.curve === 'pof' &&
                        <ValueAxis title='Probability of Failure' type={this.props.logScale ? 'logarithmic' : 'continuous'}
                            name='risk' position='left' endOnTick
                        >
                            <ConstantLine value={this.state.riskTargetPoF} dashStyle='dash' color='red' label={{ text: 'Target PoF' }} />
                        </ValueAxis>
                    }

                    <ArgumentAxis title='Year' argumentType='datetime' endOnTick>
                        <ConstantLine value={this.state.atDate} dashStyle='dash' color='blue'
                            label={{ text: 'Calculation Date', position: 'inside' }} /
                        >
                        {this.props.curve === 'risk_f' ?
                            <ConstantLine value={Date.parse(this.state.targetDateF)} dashStyle='dash' width='2px' color='red'
                                label={{ text: 'Target Date (F)', position: 'outside', font: { color: 'red' } }}
                            />
                            : this.props.curve === 'risk_a' ?
                                <ConstantLine value={Date.parse(this.state.targetDateA)} dashStyle='dash' width='2px' color='red'
                                    label={{ text: 'Target Date (A)', position: 'outside', font: { color: 'red' } }}
                                />
                                : this.props.curve === 'pof' ?
                                    <ConstantLine value={Date.parse(this.state.targetDatePoF)} dashStyle='dash' width='2px' color='red'
                                        label={{ text: 'Target Date (PoF)', position: 'outside', font: { color: 'red' } }}
                                    />
                                    : this.props.curve === 'df_total' ?
                                        <ConstantLine value={Date.parse(this.state.targetDateDfTotal)} dashStyle='dash' width='2px' color='red'
                                            label={{ text: 'Target Date (DF-total)', position: 'outside', font: { color: 'red' } }}
                                        />
                                        : <></>
                        }
                        <ConstantLine value={this.state.planDate} dashStyle='dash' color='green' width='2px'
                            label={{ text: 'Plan Date', position: 'inside', font: { color: 'green' } }}
                        />
                    </ArgumentAxis>


                    <Crosshair enabled dashStyle='dash'>
                        <Label visible format={{ precision: 2 }} />
                    </Crosshair>
                    <Export enabled />
                    <Tooltip enabled />
                    <Legend visible={false} />
                </Chart>

            </div>
        );
    }
}

export default XYPlot;